import { ListingTracking } from '@/utils/platform-api/__generated__/graphql';

import type { AidaptiveContext } from '@/utils/aidaptive-analytics';

const AIDAPTIVE_TRACKING_BASE_URL = 'https://tr.aidaptive.com';

export type ListingTrackingRecord = Record<
  string,
  { impressionUrl: string | null; clickUrl: string | null }
>;

export type AidaptiveTrackingData = {
  record: ListingTrackingRecord;
} & AidaptiveContext;

/** True when the API returned Aidaptive tracking URLs (absent for control holdout). */
export const hasAidaptiveTracking = (
  record: ListingTrackingRecord
): boolean => Object.keys(record).length > 0;

const getTrackingUrl = (path: string | null | undefined): string | null =>
  path ? `${AIDAPTIVE_TRACKING_BASE_URL}${path}` : null;

export const buildTrackingRecord = (
  tracking: ListingTracking[] | null | undefined
): ListingTrackingRecord => {
  if (!tracking) return {};
  const record: ListingTrackingRecord = {};
  for (const t of tracking) {
    record[t.listing_id] = {
      impressionUrl: getTrackingUrl(t.impression_tracker_url),
      clickUrl: getTrackingUrl(t.click_tracker_url),
    };
  }
  return record;
};
